import React from "react";
import {
  FaBookOpen,
  FaUsers,
  FaRocket,
  FaFacebook,
  FaTwitter,
  FaYoutube,
} from "react-icons/fa";

export default function BrandValuesSection() {
  return (
    <section style={outerStyle}>
      <div style={cardStyle}>
        <div className="container text-center">
          <div className="row mt-2">
            <div className="col-md-4 mb-4">
              <FaBookOpen size={40} color="#114c96" />

              <h4 className="mt-3" style={headingStyle}>Creator-Owned Since 1985</h4>

              <p style={textStyle}>
                We believe the people who make comics should own their stories,
                their characters, and their creative future.
              </p>
            </div>

            <div className="col-md-4 mb-4">
              <FaUsers size={40} color="#114c96" />

              <h4 className="mt-3" style={headingStyle}>For Readers, By Readers</h4>

              <p style={textStyle}>
                We make the kinds of comics we love to read: bold, weird, fun,
                heartfelt, independent, and unapologetically ours.
              </p>
            </div>

            <div className="col-md-4 mb-4">
              <FaRocket size={40} color="#114c96" />

              <h4 className="mt-3" style={headingStyle}>All Stories, All Genres</h4>

              <p style={textStyle}>
                From manga-inspired adventures to horror, fantasy, sci-fi,
                action, humor, and everything in between; if it&apos;s cool, we&apos;ll
                print it.
              </p>
            </div>
          </div>

          <hr className="my-5" />

          <h3 style={communityHeadingStyle}>Join the Community</h3>

          <p className="text-muted mb-4">
            Stay connected with us and never miss a new release, campaign,
            auction, or update.
          </p>

          <div className="d-flex justify-content-center gap-4">
            <a href="https://www.facebook.com/BenDunn" target="_blank" rel="noopener noreferrer">
              <FaFacebook size={36} color="#5865F2" />
            </a>

            <a href="https://x.com/APressDigital" target="_blank" rel="noopener noreferrer">
              <FaTwitter size={36} color="#1DA1F2" />
            </a>

            <a href="https://www.youtube.com/@bendunn6716" target="_blank" rel="noopener noreferrer">
              <FaYoutube size={36} color="#FF0000" />
            </a>
          </div>

          <p style={locationStyle}>
            We&apos;re located in San Antonio, Texas, by the way. Yee-haw.
            <br />
            Come on down and see us sometime.
          </p>
        </div>
      </div>
    </section>
  );
}

const outerStyle = {
  padding: "2rem 0 3rem 0",
};

const cardStyle = {
  background: "#ffffff",
  border: "1px solid #d7e2ef",
  borderTop: "5px solid #114c96",
  borderRadius: "18px",
  padding: "3rem 2rem",
  boxShadow: "0 10px 28px rgba(0,0,0,0.08)",
};

const headingStyle = {
  margin: "0 0 0.75rem 0",
  color: "#114c96",
  fontWeight: 800,
};

const textStyle = {
  margin: "0 0 1rem 0",
  color: "#334155",
  lineHeight: 1.7,
};

const communityHeadingStyle = {
  fontWeight: 800,
  color: "#000000",
};

const locationStyle = {
  marginTop: "2rem",
  color: "#334155",
  fontWeight: 600,
};
